import { useState } from "react";

export default function CeilingHeight({isSmall, errors }) {
  const [selected, setSelected] = useState([]);
    
      const handleClick = (value) => {
        if (selected.includes(value)) {
          setSelected(selected.filter((v) => v !== value)); // снимаем выбор при повторном клике
        } else {
          setSelected([...selected, value]); // выбираем новое значение
        }
  };
  
  return (
    <div
      className="ceilingHeight"
      style={{
        border: errors?.ceilingHeight ? "2px solid red" : "none",
        padding: "5px",
        borderRadius: "10px",
      }}
    >
      
      <h5>{isSmall ? "ԱՌ. ԲԱՐՁ․" : "ԱՌԱՍՏԱՂԻ ԲԱՐՁ՝․"}</h5>
      
        <div className="with">
          {["2.6", "2.8", "3", "3.2", "3.5", "3.8", "4.0", "4.5", "5.0"].map(
            (value, i) => (
              <div key={i}>
                <input
                  type="checkbox"
                  name="ceiling_height"
                  id={`c${i}`}
                  value={value}
                  checked={
                    selected.includes(value)
                  }
                  onChange={() => handleClick(value)}
                />
                <label htmlFor={`c${i}`}>{value}Մ</label>
              </div>
            ),
          )}
        </div>
      
    </div>
  );
}
